__turbopack_context__.v({
  "blok-big-title": "ProductGrid-module__brl3Cq__blok-big-title",
  "blok-subtitle": "ProductGrid-module__brl3Cq__blok-subtitle",
  "blok-title": "ProductGrid-module__brl3Cq__blok-title",
  "grid": "ProductGrid-module__brl3Cq__grid",
  "grid-container": "ProductGrid-module__brl3Cq__grid-container",
});
